import React from "react"
import autobind from "class-autobind"
import { Chip } from "material-ui"
import MultiSupervisorChips from "./MultiSupervisorChips"
import strings from "../../localization/strings"
import ToolTip from "react-portal-tooltip"

interface IProps {
    supervisorIds: string[]
    toolTipKey: string
}
interface IState {
    open: boolean
}

export default class SupervisorsToolTipColumn extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            open: false
        }
        autobind(this)
    }

    render() {
        if (this.props.supervisorIds === null || this.props.supervisorIds.length === 0) return null
        return (
            <div>
                <ToolTip
                    active={this.state.open}
                    position="left"
                    arrow="center"
                    parent={`#supervisors_tooltip_${this.props.toolTipKey}`}
                    tooltipTimeout={50}
                >
                    <div style={{ padding: 5 }}>
                        <MultiSupervisorChips
                            readonly
                            hideLabel
                            selectedSupervisorIds={this.props.supervisorIds}
                        />
                    </div>
                </ToolTip>
                <Chip
                    id={`supervisors_tooltip_${this.props.toolTipKey}`}
                    onClick={() => this.setState({ open: !this.state.open })}
                    onMouseOut={() => this.setState({ open: false })}
                >
                    {strings.Supervisors}
                </Chip>
            </div>
        )
    }
}